import { useEffect, useState } from "react";

/** Distance (in px) from the bottom of the page still considered "end of page". */
const BOTTOM_THRESHOLD_PX = 200;

/**
 * Returns `true` when the window is scrolled to the bottom of the page.
 * Pages shorter than the viewport are never considered "at the bottom",
 * so the widget remains visible on non-scrollable pages.
 */
export const usePageScrollBottom = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const checkPosition = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const isPageScrollable = scrollableHeight > BOTTOM_THRESHOLD_PX;

      setIsAtBottom(isPageScrollable && window.scrollY >= scrollableHeight - BOTTOM_THRESHOLD_PX);
    };

    window.addEventListener("scroll", checkPosition, { passive: true });
    window.addEventListener("resize", checkPosition);

    // Re-check whenever the page content changes height (route change, lazy content, images, ...)
    const observer = new ResizeObserver(checkPosition);
    observer.observe(document.documentElement);

    checkPosition();

    return () => {
      window.removeEventListener("scroll", checkPosition);
      window.removeEventListener("resize", checkPosition);
      observer.disconnect();
    };
  }, []);

  return isAtBottom;
};
